<template>
  <magic-ui
    id="app"
    ref="magicUi"
    :aegis-first-screen-timing="!hasShowMagicImageWrapper"
    :config="config"
    :page-config="pageConfig"
    :env-name="envName"
    :size="size"
    @page-created="pageCreated"
    @page-mounted="pageMounted"
  >
    <div
      v-if="showQrcode"
      class="web-qrcode-container"
    >
      <magic-ui-qr-code :config="qrcodeConfig" />
      <p>请使用手机扫码打开</p>
    </div>

    <magic-ui-notify-pop
      v-if="pageConfig.notifyModId"
      :mod-id="pageConfig.notifyModId"
    />

    <magic-ui-orientation-tip
      v-if="isShowOrientationTip && !showQrcode"
      :custom-orientation="customOrientation"
      detector="resize"
    />
  </magic-ui>
</template>

<script lang="ts">
import Vue from 'vue';
import { computed, defineComponent, getCurrentInstance, ref, onMounted } from '@vue/composition-api';

import ScreenOrientationTip from '@/web/src/components/orientation-tip';
import usePage from '@/web/src/use/use-page';
import useReport from '@/web/src/use/use-report';
import useQrcode from '@/web/src/use/use-qrcode';
import useLoginReady from '@/web/src/use/use-login-ready';
import useCustomReport from '@/web/src/use/use-custom-report';
import { hotUpdateConfig } from '@/web/src/util/socket';

/** eslint-disable */
export default defineComponent({
  components: {
    'magic-ui-orientation-tip': ScreenOrientationTip,
  },

  setup() {
    const vm = getCurrentInstance()?.proxy;
    const config = ref(window.magicUiconfig || []);
    const app = computed(() => config.value[0] || {});
    const magicUi = ref(null);

    const { env, alert } = Vue.prototype;

    if (env.isLiteApp && !app.value.liteApp) {
      alert({
        title: '极速版暂不支持',
        msg: '请前往腾讯视频APP参与活动～',
        confirm: () => {
          // @ts-ignore
          magicUi.value?.openView?.(`tenvideo2://?action=10&openurl=${window.encodeURIComponent(window.location.href)}`);
        },
      });
    }

    onMounted(() => {
      hotUpdateConfig((data) => {
        window.magicUiconfig = Vue.observable(data);
        config.value = Vue.observable(data);
      });
    });

    const pageState = usePage(app);
    useReport(app.value, pageState.pageName, vm);
    const qrCodeState = useQrcode(pageState.pageConfig);
    useLoginReady(app, vm);
    useCustomReport();

    return {
      ...pageState,
      ...qrCodeState,

      magicUi,

      config,

      hasShowMagicImageWrapper: !!window.hasShowMagicImageWrapper,
    };
  },
});
</script>
